export { default } from './EnergiaSolarFaq';
